<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <!-- <vs-button class="px-4">{{params.data.status}}</vs-button> -->
      <vs-button v-if="params.data.teacher_status == 1 && params.data.assignment_type_id!=3" class="px-4 font-bold" color="primary" type="border" @click="viewDetails">View</vs-button>
       <vs-button v-if="params.data.teacher_status == 1 && params.data.assignment_type_id==3" class="px-4 font-bold" color="primary" type="border" @click="viewDetailsReport">Fill In</vs-button>
      <vs-button v-if="params.data.teacher_status == 2 && params.data.assignment_type_id!=3" class="px-4 font-bold" color="warning" type="border" @click="viewDetails">Mark</vs-button>
      <vs-button v-if="params.data.teacher_status == 2 && params.data.assignment_type_id==3" class="px-4 font-bold" color="warning" type="border" @click="reportSubmit">Submit</vs-button>
      <vs-button v-if="params.data.teacher_status == 3 && !isAdminTeacher" class="px-4 font-bold" color="success" type="border" @click="sentMarks">{{params.data.is_sent_to_students?'Sent':'Send'}}</vs-button>
      <vs-button v-if="params.data.teacher_status == 5" class="px-4 font-bold" color="danger" type="border" @click="remind">Remind</vs-button>
      <vs-button v-if="params.data.teacher_status == 4" class="px-4 font-bold" color="danger" type="border" @click="downloadReport">Download</vs-button>
      <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

        <vs-dropdown-menu style="min-width: 100px;">
           <!-- <vs-dropdown-item v-if="params.data.teacher_status == 1"  @click="viewDetails" :disabled="resassignDisable"
          >View</vs-dropdown-item> -->
          <vs-dropdown-item @click="reassignModal" :disabled="resassignDisable"
          >Reassign</vs-dropdown-item>
           <vs-dropdown-item @click="editReport" v-if="params.data.assignment_type_id==3"
          >Edit</vs-dropdown-item>
          <!-- <vs-dropdown-item @click="openEditView">Edit</vs-dropdown-item>
          <vs-dropdown-item>Delete</vs-dropdown-item> -->
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
        <div v-if="assignOpen">

      <ReportAssignComponent
       v-if="params.data.assignment_type_id==3"
      :assignOpenModal= "assignOpen"
        :assignType="assignType"
        :dataObj="params.data"
        @assignclose="assignClose"
      />
       <AssignComponent
       v-else
       :formName="params.colDef.cellRendererParams.type"
      :assignOpenModal= "assignOpen"
        :assignType="assignType"
        :dataObj="params.data"
        @assignclose="assignClose"
      />

    </div>
  </div>
</template>

<script>
import ReportAssignComponent from '../../Reports/Template/ReportAssignModal.vue'
import AssignComponent from '../Template/AssignComponent.vue'
import {statusChng, remindApi, downloadCourseWorkPdf} from '@/api/course-work'
import axios from 'axios'

export default {
  name: 'CellRendererAction',
  components:{
    AssignComponent,
    ReportAssignComponent
  },
  data () {
    return {
      assignType: 'assign',
      assignOpen: false
    }
  },
  mounted () {
    // console.log(this.params.data)
    // 2->homewrok 3->report, 4=>exam
  },
  computed :{
    isAdminTeacher () {
      const user_id = JSON.parse(localStorage.getItem('userInfo'))
      // console.log(this.params.data)
      if (this.params.data.assignment_type_id === 3) {
        // console.log(user_id.id, this.params.data.user.id)
        return user_id.id === this.params.data.teacher.id
      } else {
        return user_id.id === this.params.data.user.id
      }

    },
    resassignDisable () {
      const date1 =  new Date(this.params.data.assignment_builder.deadline)
      const date2 = new Date()
      const Difference_In_Time = date2.getTime() - date1.getTime()
      const Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24))
      if ((Difference_In_Days > 0) && (this.params.data.assignment_builder.has_submit_after_deadline === 1 || this.params.data.assignment_builder.has_submit_after_deadline)) {
        return false
      } else {
        if (Difference_In_Time > 0) return false
        return true
      }
    }
  },
  methods: {
    async editReport () {
      this.$router.push({
        name: 'report-details',
        params: {
          assignment_type_id:this.params.data.assignment_type_id,
          assignment_builder_user_id: this.params.data.id,
          client_user: this.params.data.client_user.client_users_id
        }
      })
    },
    async reportSubmit () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        student_status:2,
        assignment_type_id: this.params.data.assignment_type_id,
        teacher_status:3
      }

      await statusChng(customer_id, this.params.data.id, payload)
      this.$vs.notify({
        title: 'Success',
        text: 'Assignment submitted successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 3000
      })
      this.params.colDef.cellRendererParams.fetchAssignmentList()
    },
    async sentMarks () {
      if (this.params.data.is_sent_to_students) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Assignment already sent',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } else {
        const customer_id = localStorage.getItem('customer_id')
        let payload = {}
        payload = {
          student_status:3,
          assignment_type_id: this.params.data.assignment_type_id
        }
        if (this.params.data.assignment_type_id === 3) {
          payload.teacher_status = 4
        }

        await statusChng(customer_id, this.params.data.id, payload)
        this.$vs.notify({
          title: 'Success',
          text: 'Assignment sent successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.params.colDef.cellRendererParams.fetchAssignmentList()
      }

    },
    async remind () {
      const customer_id = localStorage.getItem('customer_id')
      // const payload = {
      //   student_status:3,
      //   assignment_type_id: this.params.data.assignment_type_id
      // }

      await remindApi(customer_id, this.params.data.id)
      this.$vs.notify({
        title: 'Success',
        text: 'Reminder send successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 3000
      })
    },
    viewDetails () {
      if (this.params.data.assignment_type_id === 4) {
        this.$router.push({
          name: 'exam-details',
          params: {
            assignment_type_id:this.params.data.assignment_type_id,
            assignment_builder_user_id: this.params.data.id,
            client_user: this.params.data.client_user.client_users_id
          }
        })
      } else {
        this.$router.push({
          name: 'coursework-details',
          params: {
            assignment_type_id:this.params.data.assignment_type_id,
            assignment_builder_user_id: this.params.data.id,
            client_user: this.params.data.client_user.client_users_id
          }
        })
      }

    },
    viewDetailsReport () {
      this.$router.push({
        name: 'report-details',
        params: {
          assignment_type_id:this.params.data.assignment_type_id,
          assignment_builder_user_id: this.params.data.id,
          client_user: this.params.data.client_user.client_users_id
        }
      })
    },
    assignClose () {
      this.assignOpen = false
      this.$vs.loading()
      setTimeout(() => { 
        this.params.colDef.cellRendererParams.fetchAssignmentList() 
        this.$vs.loading.close()

      }, 5000)
     
     
    },
    reassignModal () {
      this.assignOpen = true
      this.assignType = 'reassign'
    },
    async downloadReport () {
      const customer_id = localStorage.getItem('customer_id')
      const payload = {
        teacher_answer:true,
        student_answer:true
      }
      const { data } = await downloadCourseWorkPdf(
        customer_id,
        this.params.data.id,
        payload
      )
      this.downloadItem({
        url: data.data.url,
        label: data.data.name
      })
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    }
  }
}
</script>
